import React from 'react';
import { TextField } from 'react-admin';

import { PoolDatagrid } from './PoolModal';

export const PoolGrid = (props) =>
  <PoolDatagrid size="medium" {...props}>
    <TextField source="name" />
  </PoolDatagrid>
